export default __webpack_public_path__ + "static/media/640_portfolio04-en-mobile.56f13460.png";